import { Layout } from 'antd';
import BuildVersion from 'common/build-version';
import EnviromentBadge from 'common/enviroment-badge';

const Footer = () => (
  <Layout.Footer
    style={{
      textAlign: 'center',
      borderTop: '1px solid #e9e9e9',
      backgroundColor: '#fff',
    }}
  >
    <div className="flex justify-between items-center gap-4">
      <EnviromentBadge />
      <div>STAG VIETNAM © {new Date().getFullYear()}</div>
      <BuildVersion />
    </div>
  </Layout.Footer>
);

export default Footer;
